import Image from "next/image";

export function Logo() {
  return (
    <div className="relative h-8 max-w-[10.847rem]">
      <Image
        src="/logo-1.png"
        fill
        className="object-contain"
        alt="Kyanon logo"
        role="presentation"
        quality={100}
      />
    </div>
  );
}
